import api from "./api";

// The policy points customers accept on the Trip Details link. Null before the first publish.
export const getCustomerPolicy = async () => {
  const { data, status } = await api.get("/api/admin/customer-policy");
  return status === 204 ? null : data || null;
};

// Publishing saves a new version; earlier versions stay as they were accepted.
export const publishCustomerPolicy = async (points) => {
  const { data } = await api.post("/api/admin/customer-policy", { points });
  return data;
};
